import { GlobEnv } from "../env"
import { namespace } from "../global"

/**
 * 全局环境变量
 */
export const useGlobEnv = (): Readonly<GlobEnv> => {
	// Get the global configuration (the configuration will be extracted independently when packaging)
	const ENV = (import.meta.env.DEV ? (import.meta.env as unknown as GlobEnv) : window[namespace]) as unknown as GlobEnv

	const {
		VITE_GLOB_APP_THEME,
		VITE_GLOB_APP_TITLE,
		VITE_GLOB_APP_KEYWORDS,
		VITE_GLOB_APP_DESCRIPTION,
		VITE_GLOB_API_URL,
		VITE_GLOB_APP_EN_NAME,
		VITE_GLOB_FILE_URL,
		VITE_GLOB_APP_LOGO,
		VITE_GLOB_APP_FAV,
		VITE_GLOB_APP_SYSTEM,
		VITE_GLOB_APP_PLATFORM,
		VITE_GLOB_APP_SITEID
	} = ENV

	if (!/[a-zA-Z\_]*/.test(VITE_GLOB_APP_EN_NAME)) {
		console.log(`VITE_GLOB_APP_SHORT_NAME Variables can only be characters/underscores, please modify in the environment variables and re-running.`)
	}

	// Take global configuration
	const glob: Readonly<GlobEnv> = {
		VITE_GLOB_APP_THEME,
		VITE_GLOB_APP_TITLE,
		VITE_GLOB_APP_KEYWORDS,
		VITE_GLOB_APP_DESCRIPTION,
		VITE_GLOB_APP_LOGO,
		VITE_GLOB_APP_FAV,
		VITE_GLOB_API_URL,
		VITE_GLOB_APP_EN_NAME,
		VITE_GLOB_FILE_URL,
		VITE_GLOB_APP_SYSTEM,
		VITE_GLOB_APP_PLATFORM,
		VITE_GLOB_APP_SITEID
	}

	return glob
}
